import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/contractor-core/anchor-date')({});